import { useRouterState } from '@tanstack/react-router';

/**
 * Whether the page on screen is /onboarding, which renders without the app
 * shell. Read from the matches the Outlet renders, not from `location`: a
 * navigation moves `location` at once but keeps the old matches on screen
 * until the next route has loaded. Going from /clu to /onboarding, a
 * location check dropped AppShell, and the CopilotRuntimeProvider inside it,
 * while /clu was still rendered, and its chat threw (Sentry
 * CLEANLIST-PORTAL-99).
 */
export const useIsOnboardingRoute = (): boolean =>
  useRouterState({
    select: (s) => s.matches.some((m) => m.routeId === '/onboarding'),
  });
